import React, { FC, memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import MaintenanceStatisticsBody from '@hkm/components/Maintenance/Statistics/Body/MaintenanceStatisticsBody';
import * as actions from '@hkm/components/Maintenance/Statistics/domain/actions';
import { selectOOOStatisticsState } from '@hkm/components/Maintenance/Statistics/domain/selectors';
import ConnectedHeader from '@hkm/components/shared/LayoutComponents/ConnectedHeader';
import APP_ROUTES from '@hkm/constants/routing.constants';

import { AcBody } from '@ac/mobile-components/dist/components/layout';

const MaintenanceStatistics: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const state = useSelector(selectOOOStatisticsState);

  useEffect(() => {
    dispatch(actions.enableRefresh());

    return () => {
      dispatch(actions.disableRefresh());
    };
  }, []);

  const showSpinner = !state.data;

  return (
    <>
      <ConnectedHeader close={APP_ROUTES.MAINTENANCE.DASHBOARD}>
        {t('MAINTENANCE_STATISTICS.TITLE')}
      </ConnectedHeader>
      {showSpinner ? (
        <AcBody showSpinner={true} testSelector="maintenanceStatistics" />
      ) : (
        <MaintenanceStatisticsBody data={state.data!} />
      )}
    </>
  );
};

export default memo(MaintenanceStatistics);



// WEBPACK FOOTER //
// ./src/components/Maintenance/Statistics/MaintenanceStatistics.tsx